<ng-container [ngSwitch]="banner.type">
  <app-opt-in-banner
    *ngSwitchCase="'optIn'"
    [cid]="cid"
    (bannerCta)="updateOptIn.emit($event)"
  ></app-opt-in-banner>

  <app-notification-banner-standard
    *ngSwitchCase="'paperlessEnrollment'"
    variant="success"
    (afterClose)="ignorePaperlessEnrollmentBanner.emit()"
    class="paperless-enrollment-banner"
  >
    <app-icon-paperless class="bewp-banner-icon"> </app-icon-paperless>
    <p class="bewp-banner-content__text">Enroll in paperless statements.</p>
    <div class="bewp-banner-content__link-container">
      <a
        *ngIf="banner.ngLink"
        id="paperLessEnrollmentLink"
        class="bewp-banner-content__link"
        [routerLink]="banner.ngLink"
        (click)="firePaperlessEnrollmentEvent()"
      >
        Enroll now
      </a>
      <a
        *ngIf="!banner.ngLink && banner.href"
        id="paperLessEnrollmentLink"
        class="bewp-banner-content__link"
        [href]="banner.href"
        (click)="firePaperlessEnrollmentEvent()"
      >
        Enroll now
      </a>
    </div>
  </app-notification-banner-standard>
</ng-container>
